module.exports = __webpack_public_path__ + "media/video.f423f54e.mp4";